/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_External_Directories_DescriptionInputs */

const en_directory_external_directories_description = /** @type {(inputs: Directory_External_Directories_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every launch directory we track for distribution, ranked by Domain Rating. Start on ${i?.app}, then work the list from the top.`)
};

const zh_directory_external_directories_description = /** @type {(inputs: Directory_External_Directories_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们跟踪的每一个发布目录，按 Domain Rating 排序。先在 ${i?.app} 上线，再从榜首逐站推进。`)
};

/**
* | output |
* | --- |
* | "Every launch directory we track for distribution, ranked by Domain Rating. Start on {app}, then work the list from the top." |
*
* @param {Directory_External_Directories_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_description = /** @type {((inputs: Directory_External_Directories_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_description(inputs)
	return zh_directory_external_directories_description(inputs)
});
export { directory_external_directories_description as "directory.external_directories.description" }